export default __webpack_public_path__ + "static/media/tables.82ce163f.png";